var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Grid, Typography } from '@mui/material';
import { TituloCardCinza } from './TituloCardCinza';
import { TipoProcessoEnum } from '../../../model/enums/TipoProcessoEnum';
import { ShowContent } from '../../../components/ShowContent';
import { RequerentePFView } from './RequerentePFView';
import { ProfileEnum } from '../../../model/enums/ProfileEnum';
import { ViewTextField } from './ViewTextField';
import { UfEnumOptions } from '../../../model/enums/UfEnum';
import { ConselhoClasseEnum } from '../../../model/enums/ConselhoClasseEnum';
import { GridView } from './GridView';
import { dadosParcela } from './FormFieldsView';
import { TipoImovelEnum } from '../../../model/enums/TipoImovelEnum';
export var ParcelaImovelView = function (_a) {
    //region Hooks
    var _b, _c, _d;
    var dadosImv = _a.dadosImv, dados = _a.dados, index = _a.index, tipoRequerimento = _a.tipoRequerimento, setActiveStep = _a.setActiveStep, invertido = _a.invertido, getStep = _a.getStep;
    var isReq06 = tipoRequerimento === TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO;
    var isUrbano = (dadosImv === null || dadosImv === void 0 ? void 0 : dadosImv.tipoImovel) === TipoImovelEnum.URBANO;
    var tiposQueMostramDadosDoImovelTrue = [
        TipoProcessoEnum.RETIFICACAO_TITULO_DEFINITIVO,
        TipoProcessoEnum.BUSCA_PESQUISA,
        TipoProcessoEnum.DECLARACAO_ASSENTADO,
        TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO,
        TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA,
    ];
    var deveMostrarDadosDoImovelTrue = function (referenciaServico) { return referenciaServico != null && tiposQueMostramDadosDoImovelTrue.includes(referenciaServico); };
    var getTodosCampos = useCallback(function () {
        return dadosParcela(tipoRequerimento, dados, dadosImv) || [];
    }, [tipoRequerimento, dados, dadosImv]);
    var isPecasTecnicasLabel = function (label) {
        return label === null || label === void 0 ? void 0 : label.toLowerCase().includes("peças técnicas");
    };
    var dadosParcelaCbk = useCallback(function () {
        var lista = getTodosCampos();
        if (isReq06) {
            return lista.filter(function (item) { return !isPecasTecnicasLabel(item.label); });
        }
        return lista;
    }, [getTodosCampos, isReq06]);
    var getValorPecasTecnicas = useCallback(function () {
        var _a, _b;
        var flagEnviar = dados === null || dados === void 0 ? void 0 : dados.enviarPecasTec;
        if (typeof flagEnviar === "boolean") {
            return flagEnviar ? "Sim" : "Não";
        }
        var temArt = !!(dados === null || dados === void 0 ? void 0 : dados.codigoArt);
        var temRT = !!((_b = (_a = dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico) === null || _a === void 0 ? void 0 : _a.pessoaFisica) === null || _b === void 0 ? void 0 : _b.cpf);
        return (temArt || temRT) ? "Sim" : "Não";
    }, [dados]);
    var valorPecas = getValorPecasTecnicas();
    var mostrarCard = (isReq06 && isUrbano) ? valorPecas === "Sim" : true;
    //endregion
    var dadosRt = useCallback(function () {
        var rt = dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico;
        return [
            {
                label: 'Conselho de Classe',
                value: ((rt === null || rt === void 0 ? void 0 : rt.conselhoClasse) ? "".concat(ConselhoClasseEnum.getSigla(rt === null || rt === void 0 ? void 0 : rt.conselhoClasse), " - ").concat(ConselhoClasseEnum.getDescricao(rt === null || rt === void 0 ? void 0 : rt.conselhoClasse)) : '')
            },
            {
                label: 'UF do Conselho de Classe',
                value: ((rt === null || rt === void 0 ? void 0 : rt.ufConselhoClasse) ? UfEnumOptions.getDescricao(rt.ufConselhoClasse) : '')
            },
            {
                label: 'Número de Registro',
                value: rt === null || rt === void 0 ? void 0 : rt.numeroRegistro
            },
            {
                label: 'Código INCRA',
                value: rt === null || rt === void 0 ? void 0 : rt.codigoIncra
            },
        ];
    }, [dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico]);
    var isNoKey = useCallback(function (obj) {
        var _a;
        return ((_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }, []);
    //endregion
    return (_jsxs(_Fragment, { children: [isReq06 && isUrbano && (_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Grid, __assign({ container: true, spacing: 2, style: { marginBottom: '16px' } }, { children: _jsx(GridView, { index: 0, option: {
                            label: "Peças técnicas?",
                            value: valorPecas,
                            fullWidth: true
                        } }) })) }))), _jsx(ShowContent, __assign({ show: mostrarCard }, { children: _jsx(TituloCardCinza, __assign({ titulo: deveMostrarDadosDoImovelTrue(tipoRequerimento) ? 'Dados do Imovel' : "Dados da Parcela ".concat(index + 1), onClick: function () { return setActiveStep === null || setActiveStep === void 0 ? void 0 : setActiveStep(1); } }, { children: _jsxs(Grid, __assign({ container: true, spacing: 2, style: { marginTop: index > 0 ? '16px' : '0' } }, { children: [(_b = dadosParcelaCbk()) === null || _b === void 0 ? void 0 : _b.map(function (option, index) { return (_jsx(ShowContent, __assign({ show: !isNoKey(option) }, { children: _jsx(GridView, { index: index, option: option }, "grid_field_".concat(index === null || index === void 0 ? void 0 : index.toString())) }), "field-".concat(index === null || index === void 0 ? void 0 : index.toString()))); }), _jsxs(ShowContent, __assign({ show: !!(dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico) }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, style: { textAlign: 'center', marginTop: '16px', marginBottom: '16px' } }, { children: _jsxs(Typography, __assign({ variant: "h6", align: "center" }, { children: ["Dados do ", ProfileEnum.getDescricao(ProfileEnum.RESPONSAVEL_TECNICO)] })) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(RequerentePFView, __assign({ pf: (_c = dados === null || dados === void 0 ? void 0 : dados.responsavelTecnico) === null || _c === void 0 ? void 0 : _c.pessoaFisica, profile: ProfileEnum.RESPONSAVEL_TECNICO, tipoRequerimento: tipoRequerimento }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, style: { textAlign: 'center', marginTop: '16px', marginBottom: '16px' } }, { children: _jsxs(Typography, __assign({ variant: "h6", align: "center" }, { children: ["Dados Profissionais do ", ProfileEnum.getDescricao(ProfileEnum.RESPONSAVEL_TECNICO)] })) })), (_d = dadosRt()) === null || _d === void 0 ? void 0 : _d.map(function (option, index) { return (_jsx(ShowContent, __assign({ show: !isNoKey(option) }, { children: _jsx(Grid, __assign({ item: true, xs: 12, xl: 6, lg: 6, md: 6 }, { children: _jsx(ViewTextField, { label: option === null || option === void 0 ? void 0 : option.label, value: option === null || option === void 0 ? void 0 : option.value, type: option === null || option === void 0 ? void 0 : option.type }) }), "row_".concat(index === null || index === void 0 ? void 0 : index.toString())) }), "row-".concat(index === null || index === void 0 ? void 0 : index.toString()))); })] })) }))] }))] })) })) }))] }));
};
